import "./header.css";
import CV from "../../assets/cv.pdf";

import HeaderSocialLinks from "./HeaderSocialLinks";
const Header = () => {
  return (
    <header id="home">
      <div className="container header-container">
        <h5>Hello I'm</h5>
        <h1>Mohamad El Haj</h1>
        <h5 className="text-light">Full Stack Developer</h5>
        <div className="cta">
          <a href={CV} download="CV-MohamadElHajHassan.pdf" className="btn">
            Download CV
          </a>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
          <a
            href="https://mohamadelhajhassancv.netlify.app/"
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer noopener"
          >
            Live CV
          </a>
        </div>
        <HeaderSocialLinks />
        <div className="img-container">
          {/* <img src={MyImage} alt="My profilePic" className="header-profile" /> */}
          <div className="img-me"></div>
          <div className="stars"></div>
          <div className="planets"></div>
        </div>
        <a href="#contact" className="scroll-down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};
export default Header;
